import { render } from "./stronaGlowna.vue?vue&type=template&id=17a56f08"
import script from "./stronaGlowna.vue?vue&type=script&lang=js"
export * from "./stronaGlowna.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__